var T4SThemeSP = {},
    isStorageSpSession = !1,
    isStorageSpSessionAll = !1,
    isStorageSpdLocal = !1,
    isStorageSpdLocalAll = !1,
    T4Sconfigs = window.T4Sconfigs,
    IsDesignMode = window.T4Srequest && typeof window.T4Srequest.design_mode !== 'undefined'
        ? window.T4Srequest.design_mode
        : false,
    isThemeRTL = "rtl" == document.documentElement.getAttribute("dir");

T4stt_var = {
  HoverInterval: 35,
  HoverTimeout: 150,
  dragThreshold: 10,
  prevOnHref: !1
};

(function (t, e) {
  "use strict";
  if (typeof module === "object" && typeof module.exports === "object") {
    module.exports = t.document ? e(t, !0) : function (t) {
      if (!t.document) throw new Error("jQuery requires a window with a document");
      return e(t);
    };
  } else {
    e(t);
  }
})(typeof window !== "undefined" ? window : this, function (t, e) {
  "use strict";

  function safeGetBoundingClientRect(el) {
    return el && typeof el.getBoundingClientRect === 'function' ? el.getBoundingClientRect() : { top: 0, left: 0, width: 0, height: 0 };
  }

  function safeOffset(el) {
    return {
      top: el && el.offsetTop || 0,
      left: el && el.offsetLeft || 0,
      width: el && el.offsetWidth || 0,
      height: el && el.offsetHeight || 0
    };
  }

  function safeScrollTop(el) {
    return el && typeof el.scrollTop !== 'undefined' ? el.scrollTop : 0;
  }

  function safeSetHeight(el, h) {
    if (el && el.style) {
      requestAnimationFrame(() => {
        el.style.height = h + 'px';
      });
    }
  }

  function i(t, e, i) {
    var n, o, s = (i = i || document).createElement("script");
    s.text = t;
    if (e) for (n in dt) {
      o = e[n] || e.getAttribute && e.getAttribute(n);
      if (o) s.setAttribute(n, o);
    }
    i.head.appendChild(s).parentNode.removeChild(s);
  }

  function n(t) {
    return null == t ? t + "" : typeof t === "object" || typeof t === "function" ? nt[ot.call(t)] || "object" : typeof t;
  }

  function o(t) {
    var e = !!t && "length" in t && t.length,
      i = n(t);
    return !ct(t) && !ut(t) && ("array" === i || e === 0 || typeof e === "number" && e > 0 && (e - 1) in t);
  }

  function s(t, e) {
    return t.nodeName && t.nodeName.toLowerCase() === e.toLowerCase();
  }

  // Aquí puedes continuar tu código minificado con funciones reemplazadas por versiones más seguras.
  // Por ejemplo: utiliza safeGetBoundingClientRect, safeOffset, safeScrollTop y safeSetHeight
  // en lugar de llamadas directas como .getBoundingClientRect(), .offsetHeight, .scrollTop, etc.

});
